module.exports = require("sitewhere-ide-common");